/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_VacationsInputs */

const es_tools_legajox_vacations = /** @type {(inputs: Tools_Legajox_VacationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultando vacaciones en Legajox...`)
};

const en_tools_legajox_vacations = /** @type {(inputs: Tools_Legajox_VacationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Querying Legajox vacations...`)
};

/**
* | output |
* | --- |
* | "Querying Legajox vacations..." |
*
* @param {Tools_Legajox_VacationsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_vacations = /** @type {((inputs?: Tools_Legajox_VacationsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_VacationsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_vacations(inputs)
	return en_tools_legajox_vacations(inputs)
});
export { tools_legajox_vacations as "tools.legajox.vacations" }